import { actionTypes } from '../../actionTypes';
import * as apiRoutes from '../../apiRoutes';
import { ErrorData, APIUrl } from '../../constants';
import * as api from '../../tools/apiMiddleware';

const initialState = { isLoading: true, lists: [], hasErrorOccured: false, errorData: ErrorData };

export const actionCreators = {
    getCueHistory: (programmeId, cueId) => async (dispatch, getState) => {

        let url = APIUrl + apiRoutes.CueHistory + `/${programmeId}/${cueId}`;
        api.getRequest(dispatch, url, actionTypes.GET_CUE_HISTORY, actionTypes.GET_CUE_HISTORY_SUCCESS, actionTypes.GET_CUE_HISTORY_FAIL);

    },
    clearErrorMessage: () => (dispatch, getState) => {

        dispatch({ type: actionTypes.CUE_HISTORY_CLEAR_ERROR });

    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case actionTypes.GET_CUE_HISTORY:
            return {
                ...state,
                isLoading: true,
                lists: state.lists,
                hasErrorOccured: false
            };
        case actionTypes.GET_CUE_HISTORY_SUCCESS:
            return {
                ...state,
                lists: action.data,
                isLoading: false,
                hasErrorOccured: false
            };
        case actionTypes.GET_CUE_HISTORY_FAIL:
            return {
                ...state,
                isLoading: false,
                lists: state.lists,
                hasErrorOccured: true,
                errorData: action.data
            };
        case actionTypes.CUE_HISTORY_CLEAR_ERROR:
            return {
                ...state,
                isLoading: false,
                lists: state.lists,
                hasErrorOccured: false
            };
    }

    return state;
};


// WEBPACK FOOTER //
// ./src/store/Cues/CueHistoryStore.js